import { render } from "./QBE.vue?vue&type=template&id=0d4e8023&ts=true"
import script from "./QBE.vue?vue&type=script&lang=ts"
export * from "./QBE.vue?vue&type=script&lang=ts"

import "./QBE.vue?vue&type=style&index=0&id=0d4e8023&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__